import { render } from "./StreamWrapper.vue?vue&type=template&id=3d246047"
import script from "./StreamWrapper.vue?vue&type=script&lang=js"
export * from "./StreamWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__